<template>
    <div class="w-full">
        <div class="form-group px-2">
            <label for="selected_owner" class="form-label">Odaberi vlasnika lokacije</label>
            <v-select id="selected_owner"
                v-model="selectedOwner"
                label="title"
                name="owner"
                :options="allOwners"
                :multiple="true"
            >
                <template slot="no-options">
                    Pretraživanje vlasnika
                </template>
            </v-select>
        </div>

        <div class="form-group px-2">
            <label for="selected_location" class="form-label">Odaberi lokaciju</label>
            <v-select id="selected_location"
                v-model="selectedLocation"
                label="title"
                name="location"
                :options="allLocations"
                :multiple="true"
            >
                <template slot="no-options">
                    Pretraživanje lokacija
                </template>
            </v-select>
        </div>

        <div class="form-group px-2">
            <label for="selected_product" class="form-label">Odaberi tip opreme</label>
            <v-select id="selected_product"
                v-model="selectedProducts"
                label="title"
                :options="allProducts"
                :multiple="true"
            >
                <template slot="no-options">
                    Pretraživanje po tipu opreme
                </template>
            </v-select>
        </div>

        <div class="flex justify-between px-2 mt-8">
            <div class="pr-2 w-1/2">
                <datepicker class="test" input-class="form-control" placeholder="Datum prvog Reversa od:" :language="hr" v-model="selectedDateFrom"></datepicker>
            </div>

            <div class="pl-2 w-1/2">
                <datepicker input-class="form-control " placeholder="Datum prvog Reversa do:" :language="hr" v-model="selectedDateTo"></datepicker>
            </div>
        </div>

        <div class="flex justify-between mt-4">
            <button @click="exportFiltered" class="btn btn-export text-lg border-hl_yellow hover:border-yellow mt-6">
                <span>Izvoz podataka</span>
            </button>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue'
    import vSelect from 'vue-select'
    import Datepicker from "vuejs-datepicker/dist/vuejs-datepicker.esm.js";
    import {hr} from 'vuejs-datepicker/dist/locale'

export default {
    props: {
        locations: {
            type: Array,
            default: () => ([])
        },

        owners: {
            type: Array,
            default: () => ([])
        },

        products: {
            type: Array,
            default: () => ([])
        },
    },

    components: {
        vSelect,
        Datepicker,
    },

    mounted() {
    },

    data() {
        return {
            allOwners: this.owners,
            allLocations: this.locations,
            allProducts: this.products,
            selectedLocation: [],
            selectedOwner: [],
            selectedProducts: [],
            selectedDateFrom: '',
            selectedDateTo: '',
            hr: hr,

        }
    },

    methods: {
        exportFiltered() {
            let filterData = []

            if (this.selectedLocation) {
                let locationIds = []
                this.selectedLocation.forEach((location) => {
                    locationIds.push(location.id)
                })
                filterData.location = locationIds
            }

            if (this.selectedOwner) {
                let ownerIds = []
                this.selectedOwner.forEach((owner) => {
                    ownerIds.push(owner.id)
                })
                filterData.owner = ownerIds
            }

            if (this.selectedProducts) {
                let productIds = []
                this.selectedProducts.forEach((product) => {
                    productIds.push(product.id)
                })
                filterData.products = productIds
            }

            if (this.selectedDateFrom) {
                filterData.selectedDateFrom = this.selectedDateFrom
            }

            if (this.selectedDateTo) {
                filterData.selectedDateTo = this.selectedDateTo
            }

            window.location = route('admin.equipment.export', { data: filterData })
        },
    }
}
</script>
